var _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpExpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_788_4781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 2,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.7143,
    y: 2.57143,
    width: 15.4286,
    height: 15.4286,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_788_4781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4286 15.1554C18.3429 15.1554 18.2625 15.142 18.1875 15.1152C18.1125 15.0884 18.0429 15.0429 17.9786 14.9786L13.7357 10.7357C13.6071 10.6071 13.5429 10.4545 13.5429 10.2777C13.5429 10.1009 13.6071 9.94822 13.7357 9.81965C13.8643 9.69107 14.0143 9.62679 14.1857 9.62679C14.3571 9.62679 14.5071 9.69107 14.6357 9.81965L17.7857 12.9696V5.76965C17.7857 5.5875 17.8473 5.4375 17.9705 5.31965C18.0938 5.20179 18.2464 5.14286 18.4286 5.14286C18.6107 5.14286 18.7634 5.20447 18.8866 5.32768C19.0098 5.4509 19.0714 5.60357 19.0714 5.78572V12.9696L22.2214 9.81965C22.35 9.69107 22.5 9.62679 22.6714 9.62679C22.8429 9.62679 22.9929 9.69107 23.1214 9.81965C23.25 9.94822 23.3143 10.1009 23.3143 10.2777C23.3143 10.4545 23.25 10.6071 23.1214 10.7357L18.8786 14.9786C18.8143 15.0429 18.7446 15.0884 18.6696 15.1152C18.5946 15.142 18.5143 15.1554 18.4286 15.1554Z",
    fill: "#1C1B1F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_788_4781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.4286,
    height: 15.4286,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_788_4781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7143 12.8571C7.53215 12.8571 7.37948 12.7955 7.25626 12.6723C7.13305 12.5491 7.07144 12.3964 7.07144 12.2143V5.03036L3.93751 8.16429C3.80894 8.29286 3.65626 8.35714 3.47948 8.35714C3.30269 8.35714 3.15001 8.29286 3.02144 8.16429C2.89287 8.03571 2.82858 7.88571 2.82858 7.71429C2.82858 7.54286 2.89287 7.39286 3.02144 7.26429L7.2643 3.02143C7.32858 2.95714 7.39823 2.91161 7.47323 2.88482C7.54823 2.85804 7.62858 2.84464 7.7143 2.84464C7.80001 2.84464 7.88305 2.85804 7.9634 2.88482C8.04376 2.91161 8.11073 2.95714 8.1643 3.02143L12.4072 7.26429C12.5357 7.39286 12.6 7.54286 12.6 7.71429C12.6 7.88571 12.5357 8.03571 12.4072 8.16429C12.2786 8.29286 12.1259 8.35714 11.9491 8.35714C11.7723 8.35714 11.6197 8.29286 11.4911 8.16429L8.35715 5.03036V12.2143C8.35715 12.3964 8.29555 12.5491 8.17233 12.6723C8.04912 12.7955 7.89644 12.8571 7.7143 12.8571Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpExpIcon);
export default __webpack_public_path__ + "static/media/ImpExpIcon.b2a9f9f6804088708bc392f6103fc995.svg";
export { ForwardRef as ReactComponent };